export const LAYOUT_SET_TRANSLATIONS = 'LAYOUT_SET_TRANSLATIONS';
export const LAYOUT_SET_CSRF_TOKEN = 'LAYOUT_SET_CSRF_TOKEN';
export const LAYOUT_SET_CONFIG = 'LAYOUT_SET_CONFIG';

export const setTranslationsAction = ( trans ) => {

    return {
        type: LAYOUT_SET_TRANSLATIONS,
        payload: trans
    };

};

export const setTokenAction = ( token ) => {

    return {
        type: LAYOUT_SET_CSRF_TOKEN,
        payload: token
    };

};

export const setConfigAction = ( config ) => {

    return {
        type: LAYOUT_SET_CONFIG,
        payload: config
    };

};